import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from 'config/axios';
import {
    FETCH_VIEWER_USER_PREFERENCES,
    FETCH_VIEWER_USER_PREFERENCES_FETCHING,
    FETCH_VIEWER_USER_PREFERENCES_SUCCESS,
    FETCH_VIEWER_USER_PREFERENCES_FAIL,
    UPDATE_VIEWER_USER_PREFERENCES,
    UPDATE_VIEWER_USER_PREFERENCES_UPDATING,
    UPDATE_VIEWER_USER_PREFERENCES_SUCCESS,
    UPDATE_VIEWER_USER_PREFERENCES_FAIL
} from '../actions/ActionTypes';

import { handlingErrorCallback, handlingSuccessCallback } from './sagasUtils';

// Workers
export function* fetchViewerUserPreferences() {
    try {
        yield put({
            type: FETCH_VIEWER_USER_PREFERENCES_FETCHING
        });

        const response = yield call(gcApi.get, '/userprofile-service/userprofile/settings');

        yield put({
            type: FETCH_VIEWER_USER_PREFERENCES_SUCCESS,
            viewerUserPreferences: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_VIEWER_USER_PREFERENCES_FAIL
        });
    }
}

export function* updateViewerUserPreferences(action = {}) {
    const { newViewerUserPreferences, callback } = action;

    try {
        yield put({
            type: UPDATE_VIEWER_USER_PREFERENCES_UPDATING
        });

        const response = yield call(gcApi.put, '/userprofile-service/userprofile/settings', newViewerUserPreferences);

        yield call(handlingSuccessCallback, callback, response);

        yield put({
            type: UPDATE_VIEWER_USER_PREFERENCES_SUCCESS,
            viewerUserPreferences: response.data
        });
    } catch (e) {
        yield call(handlingErrorCallback, callback, e);
        yield put({
            type: UPDATE_VIEWER_USER_PREFERENCES_FAIL
        });
    }
}

// Watchers
export const viewerUserPreferencesSagas = [
    takeEvery(FETCH_VIEWER_USER_PREFERENCES, fetchViewerUserPreferences),
    takeEvery(UPDATE_VIEWER_USER_PREFERENCES, updateViewerUserPreferences)
];
